import React from 'react'
import StructuredData from './StructuredData'

export const getPlaceData = ({ name }) => {
  return {
    '@type': 'Place',
    name,
  }
}

export const getSaltPalacePlaceData = () => {
  return {
    '@type': 'EventVenue',
    name: 'Salt Palace Convention Center',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '100 S W Temple St',
      addressLocality: 'Salt Lake City',
      addressRegion: 'UT',
      postalCode: '84101',
      addressCountry: 'US',
    },
    url: 'https://www.visitsaltlake.com/salt-palace-convention-center/',
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 40.7683,
      longitude: -111.8952,
    },
    sameAs: [
      'https://en.wikipedia.org/wiki/Salt_Palace',
      'https://www.visitsaltlake.com/salt-palace-convention-center/',
    ],
  }
}

export const getLondonPlaceData = () => {
  return {
    '@type': 'EventVenue',
    name: 'ExCeL London',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '1 Western Gateway, Royal Victoria Dock',
      addressLocality: 'London',
      postalCode: 'E16 1XL',
      addressCountry: 'GB',
    },
    url: 'https://www.excel.london/',
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 51.5081,
      longitude: 0.0299,
    },
    sameAs: ['https://en.wikipedia.org/wiki/ExCeL_London', 'https://www.excel.london/'],
  }
}

export default function PlaceStructuredData({ data }) {
  if (!data || Object.keys(data).length === 0) return null
  const structuredData = getPlaceData({ name: data })

  return <StructuredData data={structuredData} dataTestId="place-structured-data" />
}
